import * as commonConst from 'app/constants/commons';
import { HYDRATE } from 'next-redux-wrapper';
import { GlobalData } from 'types/commons';
import { User } from 'types/auth';
import env from '.env.json';

let initState: GlobalData = {
  blogs: [],
  blogs_footer: [],
  auth: {} as User,
  messages: [],
  deviceType: '',
}

export const setAvatarUser = (auth: User) => {
  let avatar = '';
  const image = auth.id ? `https://ui-avatars.com/api/?name=${auth.name}&color=fff&background=random` : null;

  if (auth && auth.avatar) {
    avatar = auth.avatar?.includes('http') ? auth.avatar : `${env.URL_API}/storage/${auth.avatar}`;
  }

  return avatar || image || '';
}

export const setUser = (auth: User) => {
  auth.avatar = setAvatarUser(auth);
  return auth;
}

const global = (state = initState, action: any) => {
  switch (action.type) {
    case HYDRATE:
      if (action.payload.global?.blogs?.length) {
        return {
          ...state,
          ...action.payload.global,
        };
      }

      return state;
    case commonConst.SET_GLOBAL_DATA:
      return {
        ...state,
        ...action.payload,
        auth: setUser(action.payload.auth),
      };
    case commonConst.SET_USER_LOGIN:
      return {
        ...state,
        auth: setUser(action.payload),
      }
    default:
      return state;
  }
}

export default global
